<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Pagamentos'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && (dataPayment !== '' && !dataPayment.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Barra de ações em massa -->
            <transition name="slide-up">
              <div v-if="selectedList.length" class="batch-bar">
                <div class="batch-bar-info">
                  <strong>{{ selectedList.length }}</strong>
                  {{ selectedList.length === 1 ? 'fatura selecionada' : 'faturas selecionadas' }}
                  <span class="batch-bar-total">{{ selectedTotal | currency('R$', 2, {decimalSeparator: ','}) }}</span>
                </div>
                <div class="batch-bar-actions">
                  <a class="batch-bar-clear" @click="clearSelection">Limpar seleção</a>
                  <button type="button" class="btn btn-primary" @click="openBatch">
                    <i class="fa fa-file-text-o"></i> Emitir NFs em lote
                  </button>
                </div>
              </div>
            </transition>

            <!-- Table -->
            <div v-if="!loadingList && dataPayment.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de pagamento ({{ qtdTotal }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th class="col-check">
                          <input type="checkbox" :checked="allOnPageSelected" @change="togglePage($event.target.checked)"
                                 title="Selecionar todas desta página">
                        </th>
                        <th> EMPRESA</th>
                        <th> FUNCIONÁRIOS</th>
                        <th> PAGAMENTO POR</th>
                        <th> PREÇO</th>
                        <th> POR FUNCIONÁRIO</th>
                        <th> VALOR TOTAL</th>
                        <th> STATUS</th>
                        <th> DATA VENCIMENTO</th>
                        <th> DATA PAGAMENTO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="dt in dataPayment" :key="dt.id" :class="{'row-selected': isSelected(dt)}">
                        <td class="col-check">
                          <input type="checkbox" :checked="isSelected(dt)" @change="toggle(dt)">
                        </td>
                        <td>{{ dt.companyName }}</td>
                        <td>{{ dt.employees }}</td>
                        <td>{{ dt.paymentMethodStr }}</td>
                        <td>{{ dt.price | currency('R$', 2, {decimalSeparator: ','}) }}</td>
                        <td>{{ dt.pricePerEmployee | currency('R$', 2, {decimalSeparator: ','}) }}</td>
                        <td>{{ dt.totalCost | currency('R$', 2, {decimalSeparator: ','}) }}</td>
                        <td>{{ dt.paymentStatusStr }}</td>
                        <td>{{ dt.expireAtStr }}</td>
                        <td>{{ dt.paidAtStr }}</td>
                        <td>
                          <a v-bind:href="'/detalhe-pagamento/' + dt.id + '/' + dt.subscriptionId" title="Visualizar"
                             class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                          </a>
                          <a v-on:click="cancelInvoice(dt.id)" title="Cancelar Boleto" class="btn-to-delete">
                            <i class="fa fa-times" aria-hidden="true"></i> Cancelar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Pagination -->
                <paginate v-if="totalPages > 1"
                          v-model="pageNumber"
                          :page-count="totalPages"
                          :click-handler="listPayment"
                          :prev-text="'Anterior'"
                          :next-text="'Próximo'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <batch-invoice-modal ref="batchModal" :items="selectedList" @removed="removeFromSelection"
                         @finished="onBatchFinished"/>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import swal from 'sweetalert';
import batchInvoiceModal from "./batchInvoiceModal.vue";

import {PAYMENTS, CANCEL_INVOICE} from "../../../../../urlConfig";
import {REQUEST_SERVICE} from "../../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../../requestConfig";
import {UTIL} from "../../../../../utils";

export default {
  name: "list-payment",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    batchInvoiceModal
  },
  data() {
    return {
      failRequest: false,
      loadingList: false,
      pageNumber: 1,
      qtdTotal: 0,
      pageQtd: 20,
      totalPages: 0,
      dataPayment: {},
      selected: {}
    }
  },
  computed: {
    selectedList() {
      return Object.keys(this.selected).map((id) => this.selected[id]);
    },
    selectedTotal() {
      return this.selectedList.reduce((s, p) => s + (Number(p.totalCost) || 0), 0);
    },
    allOnPageSelected() {
      return this.dataPayment.length > 0 && this.dataPayment.every((p) => !!this.selected[p.id]);
    }
  },
  methods: {
    isSelected(dt) {
      return !!this.selected[dt.id];
    },
    toggle(dt) {
      if (this.selected[dt.id]) {
        this.$delete(this.selected, dt.id);
      } else {
        this.$set(this.selected, dt.id, dt);
      }
    },
    togglePage(checked) {
      this.dataPayment.forEach((p) => {
        if (checked) {
          this.$set(this.selected, p.id, p);
        } else {
          this.$delete(this.selected, p.id);
        }
      });
    },
    clearSelection() {
      this.selected = {};
    },
    removeFromSelection(id) {
      this.$delete(this.selected, id);
    },
    openBatch() {
      this.$refs.batchModal.open();
    },
    onBatchFinished(okIds) {
      okIds.forEach((id) => this.$delete(this.selected, id));
    },
    listPayment(page) {
      this.loadingList = true;

      if (page) this.pageNumber = page;

      let url = PAYMENTS;
      url += "?pageNumber=" + this.pageNumber + "&pageQtd=" + this.pageQtd;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT PAYMENTS:", response.data);

        this.dataPayment = response.data.items;
        this.qtdTotal = response.data.totalItems;
        this.totalPages = (response.data.totalItems / this.pageQtd);

        this.loadingList = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    cancelInvoice(id) {
      this.loadingList = true;
      REQUEST_SERVICE.get(CANCEL_INVOICE + id).then((response) => {
        UTIL_SERVICE.console("RESULT CANCEL_INVOICE:", response.data);
        swal("Aviso", response.data, "success");

        this.listPending(1);
      }).catch((reason) => {
        this.loadingList = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.listPayment();

    if (UTIL.checkP(JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id) === false) {
      this.$router.push({path: '/'});
    }
  }
}
</script>

<style lang="scss" scoped>
.col-check {
  width: 36px;
  input {
    cursor: pointer;
  }
}
.row-selected td {
  background: #eef5fc;
}
.batch-bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 15px 12px;
  padding: 12px 18px;
  background: #1f2d3d;
  color: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}
.batch-bar-total {
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  opacity: 0.85;
}
.batch-bar-actions {
  display: flex;
  align-items: center;
}
.batch-bar-clear {
  margin-right: 18px;
  color: #cfd8e3;
  cursor: pointer;
  &:hover {
    color: #fff;
    text-decoration: underline;
  }
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.2s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/payment/listPayment/listPayment.vue